import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { useAuth } from "../helper/useAuth";

interface UpdateCampaignBudgetParams {
  campaign_id: string | number;
  google_campaign_id: string;
  google_campaign_budget_id: string | number;
  google_campaign_budget: number;
}

export const useUpdateCampaignBudget = () => {
  const queryClient = useQueryClient();
  const { selectedIntegration } = useAuth();

  return useMutation<any, Error, UpdateCampaignBudgetParams>({
    mutationFn: async (params: UpdateCampaignBudgetParams) => {
      return httpService.post<any, UpdateCampaignBudgetParams>(
        API_CONFIG.path.updateCampaignBudget,
        params,
        { tracking_id: selectedIntegration?.value as string },
      );
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["google-ads-campaign-detail", String(variables.campaign_id)],
      });
      queryClient.invalidateQueries({
        queryKey: ["campaigns"],
      });
    },
  });
};
